<template>
	<ProgressSpinner v-if="!company"/>
	<Container class="pt-6" v-if="company">
		<div class="bg-surface-0 dark:bg-surface-900 -mx-8 px-8 -mt-6 pt-6 -mb-4 pb-4">
			<PageHeading>{{ company.name ?? $route.params.company }}</PageHeading>
		</div>

		<div class="sticky top-0 bg-surface-0 dark:bg-surface-800 z-40 -mx-8 -px-8">
			<TabLayout :tabs="tabs" sticky/>
		</div>

		<router-view
				@on-save="$emit('on-save')"
				@on-delete="$emit('on-delete')"
				:company="company"
		></router-view>
	</Container>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import TabLayout from "@/Layouts/TabLayout.vue";
import { mapStores } from "pinia";
import { useCompaniesStore } from "@/stores/companies.js";
import Container from "@/Components/Container.vue";


export default {
	name: "CompanyAdminView",
	components: {Container, TabLayout, PageHeading},
	data() {
		return {
			company: undefined,
		}
	},
	emits: [
		'on-save',
		'on-delete',
	],
	watch: {
		'$route.params.company': {
			async handler(newValue, oldValue) {
				if(newValue){
					if(this.$route.params.company === 'NEW'){
						this.company = {};
					} else {
						this.company = await this.companiesStore.showCompany(this.$route.params.company);
					}
				} else {
					this.company = undefined;
				}
			},
			immediate: true,
		}
	},
	computed: {
		...mapStores(useCompaniesStore),
		tabs() {
			return [
				{
					label: this.$t('common.properties'),
					current: this.$route.name === 'admin.companies.company',
					to: {name: 'admin.companies.company', params: this.$route.params}
				},
				{
          label: this.$t('common.history'),
					current: this.$route.name === 'admin.companies.company.history',
					to: {name: 'admin.companies.company.history', params: this.$route.params}
				},
			]
		}
	},
}
</script>
